// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"514":"de0f9846","761":"adb20acb"}[chunkId] + ".chunk.js";
};